import { stepDelayMinutes, type DripSequence, type DripStep } from '@/api/drip'

/** A delay in words: "straight away", "2 hours", "3 days". */
export function delayText(minutes: number): string {
  if (minutes <= 0) return 'straight away'
  if (minutes % (60 * 24) === 0) {
    const d = minutes / (60 * 24)
    return `${d} day${d === 1 ? '' : 's'}`
  }
  if (minutes % 60 === 0) {
    const h = minutes / 60
    return `${h} hour${h === 1 ? '' : 's'}`
  }
  return `${minutes} minute${minutes === 1 ? '' : 's'}`
}

/** "3 emails over 6 days". */
export function cadenceText(steps: DripStep[]): string {
  if (steps.length === 0) return 'No emails yet'
  const last = Math.max(...steps.map(stepDelayMinutes))
  const n = `${steps.length} email${steps.length === 1 ? '' : 's'}`
  return last <= 0 ? n : `${n} over ${delayText(last)}`
}

/** "9:00–17:00" or "Any time". */
export function windowText(s: Pick<DripSequence, 'sendWindowStart' | 'sendWindowEnd'>): string {
  return s.sendWindowStart && s.sendWindowEnd ? `${s.sendWindowStart.slice(0, 5)}–${s.sendWindowEnd.slice(0, 5)}` : 'Any time'
}
